import { httpsCallable } from "firebase/functions";

import { functionsClient } from "./firebase";
import type { AccountSummary } from "../types/account";
export {
  accountCanBeSelected,
  chooseActiveAccount,
  isUsableAccount,
} from "./accountSelection";

export type GetMyAccountsResponse = {
  accounts: AccountSummary[];
};

/**
 * Resolve the accounts from the backend-owned UID ↔ account relation. The
 * optional active account is deliberately not sent: it is only a UI choice.
 */
export async function getMyAccounts() {
  const callable = httpsCallable<Record<string, never>, GetMyAccountsResponse>(
    functionsClient,
    "getMyAccounts"
  );
  return (await callable({})).data.accounts;
}
